import {useWikiStore} from "~/store/wiki"

export default defineNuxtRouteMiddleware(() => {
    useWikiStore().anchor = null
})
